/**
 * @generated SignedSource<<6b948efb0ac69be6f577a6456d4f9f75>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UpdateStateFilter = "ACTIVE" | "AT_RISK" | "CANCELLED" | "DONE" | "NO_UPDATE" | "OFF_TRACK" | "ON_TRACK" | "PAUSED" | "PENDING";
export type GoalUpdatesViewQuery$variables = {
  completedGoalsTqlQuery: string;
  endDate?: string | null;
  isNavRefreshEnabled: boolean;
  newGoalsTqlQuery: string;
  ownGoalsTqlQuery: string;
  prevDate?: string | null;
  startDate?: string | null;
  stateFilter?: UpdateStateFilter | null;
  workspaceId: string;
  workspaceUUID: string;
};
export type GoalUpdatesViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GoalUpdatesMainColumn" | "GoalUpdatesSideColumn">;
};
export type GoalUpdatesViewQuery = {
  response: GoalUpdatesViewQuery$data;
  variables: GoalUpdatesViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "completedGoalsTqlQuery"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isNavRefreshEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "newGoalsTqlQuery"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ownGoalsTqlQuery"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "prevDate"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stateFilter"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUUID"
},
v10 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "endDate"
},
v11 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDate"
},
v12 = {
  "kind": "Variable",
  "name": "stateFilter",
  "variableName": "stateFilter"
},
v13 = {
  "kind": "Variable",
  "name": "workspaceId",
  "variableName": "workspaceId"
},
v14 = {
  "kind": "Variable",
  "name": "workspaceUUID",
  "variableName": "workspaceUUID"
},
v15 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUUID"
},
v16 = {
  "kind": "ScalarField",
  "name": "count"
},
v17 = [
  (v16/*: any*/)
],
v18 = {
  "kind": "ScalarField",
  "name": "id"
},
v19 = [
  {
    "kind": "Variable",
    "name": "createdAfter",
    "variableName": "startDate"
  },
  {
    "kind": "Variable",
    "name": "createdBefore",
    "variableName": "endDate"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  (v12/*: any*/),
  (v13/*: any*/)
],
v20 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v21 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v22 = {
  "kind": "ScalarField",
  "name": "picture"
},
v23 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v24 = {
  "kind": "ScalarField",
  "name": "name"
},
v25 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v26 = {
  "kind": "ScalarField",
  "name": "ari"
},
v27 = [
  (v18/*: any*/)
],
v28 = {
  "kind": "ScalarField",
  "name": "key"
},
v29 = {
  "concreteType": "GoalIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v28/*: any*/),
    {
      "kind": "ScalarField",
      "name": "appearance"
    }
  ]
},
v30 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v31 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
],
v32 = {
  "kind": "ScalarField",
  "name": "value"
},
v33 = {
  "kind": "ScalarField",
  "name": "score"
},
v34 = {
  "alias": "goalStateValue",
  "kind": "ScalarField",
  "name": "value"
},
v35 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v36 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v37 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v36/*: any*/)
},
v38 = {
  "concreteType": "CompletionGoalState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v35/*: any*/),
    (v37/*: any*/),
    (v32/*: any*/),
    (v33/*: any*/)
  ]
},
v39 = [
  (v32/*: any*/),
  (v18/*: any*/)
],
v40 = {
  "kind": "ScalarField",
  "name": "type"
},
v41 = {
  "kind": "ScalarField",
  "name": "archived"
},
v42 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v43 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v44 = [
  {
    "kind": "ScalarField",
    "name": "confidence"
  },
  {
    "kind": "ScalarField",
    "name": "label"
  },
  (v37/*: any*/),
  {
    "alias": "tooltip",
    "args": (v43/*: any*/),
    "kind": "ScalarField",
    "name": "label",
    "storageKey": "label(longFormat:true)"
  },
  {
    "alias": "localizedTooltip",
    "args": (v43/*: any*/),
    "concreteType": "LocalizationField",
    "kind": "LinkedField",
    "name": "localizedLabel",
    "plural": false,
    "selections": (v36/*: any*/),
    "storageKey": "localizedLabel(longFormat:true)"
  },
  {
    "kind": "ScalarField",
    "name": "overdue"
  }
],
v45 = {
  "kind": "ScalarField",
  "name": "summary"
},
v46 = [
  {
    "kind": "ScalarField",
    "name": "active"
  },
  {
    "kind": "ScalarField",
    "name": "missed"
  },
  {
    "kind": "ScalarField",
    "name": "atRisk"
  },
  {
    "kind": "ScalarField",
    "name": "onTrack"
  },
  {
    "kind": "ScalarField",
    "name": "offTrack"
  },
  {
    "kind": "ScalarField",
    "name": "done"
  },
  {
    "kind": "ScalarField",
    "name": "cancelled"
  }
],
v47 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v48 = {
  "kind": "Literal",
  "name": "sorts",
  "value": [
    "CREATION_DATE_DESC"
  ]
},
v49 = [
  (v16/*: any*/),
  {
    "concreteType": "GoalEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "Goal",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v18/*: any*/),
          (v28/*: any*/),
          (v20/*: any*/),
          (v29/*: any*/),
          (v24/*: any*/),
          {
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v21/*: any*/),
              {
                "concreteType": "UserPII",
                "kind": "LinkedField",
                "name": "pii",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  (v23/*: any*/)
                ]
              },
              (v18/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalUpdatesViewQuery",
    "selections": [
      {
        "args": [
          (v10/*: any*/),
          {
            "kind": "Variable",
            "name": "prevDate",
            "variableName": "prevDate"
          },
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GoalUpdatesMainColumn"
      },
      {
        "condition": "isNavRefreshEnabled",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "completedGoalsTqlQuery",
                "variableName": "completedGoalsTqlQuery"
              },
              {
                "kind": "Variable",
                "name": "newGoalsTqlQuery",
                "variableName": "newGoalsTqlQuery"
              },
              {
                "kind": "Variable",
                "name": "ownGoalsTqlQuery",
                "variableName": "ownGoalsTqlQuery"
              },
              (v15/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "GoalUpdatesSideColumn"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalUpdatesViewQuery",
    "selections": [
      {
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "args": [
              (v13/*: any*/)
            ],
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "goalsWatching",
            "plural": false,
            "selections": (v17/*: any*/)
          },
          (v18/*: any*/)
        ]
      },
      {
        "args": [
          {
            "kind": "Literal",
            "name": "stateFilter",
            "value": "ACTIVE"
          },
          (v14/*: any*/)
        ],
        "kind": "ScalarField",
        "name": "allWatchedGoalUpdatesCount"
      },
      {
        "args": (v19/*: any*/),
        "concreteType": "UpdateConnection",
        "kind": "LinkedField",
        "name": "allWatchedGoalUpdates",
        "plural": false,
        "selections": [
          {
            "concreteType": "UpdateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v18/*: any*/),
                      (v20/*: any*/),
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v18/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "missedUpdate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "updateType"
                      },
                      {
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/),
                          (v20/*: any*/),
                          {
                            "concreteType": "Workspace",
                            "kind": "LinkedField",
                            "name": "workspace",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v18/*: any*/)
                            ]
                          },
                          (v18/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "watching"
                          },
                          {
                            "concreteType": "Goal",
                            "kind": "LinkedField",
                            "name": "parentGoal",
                            "plural": false,
                            "selections": (v27/*: any*/)
                          },
                          (v28/*: any*/),
                          (v24/*: any*/),
                          (v29/*: any*/),
                          {
                            "concreteType": "GoalUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v30/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "latestUpdateDate"
                          },
                          {
                            "concreteType": "GoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": (v17/*: any*/)
                          },
                          {
                            "concreteType": "MetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "MetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "MetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "startValue"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "targetValue"
                                      },
                                      (v18/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "args": (v31/*: any*/),
                            "concreteType": "TagConnection",
                            "kind": "LinkedField",
                            "name": "tagsWatchedByUser",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TagEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Tag",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v18/*: any*/),
                                      (v24/*: any*/),
                                      (v20/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "description"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "projectUsageCount"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "goalUsageCount"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "helpPointerUsageCount"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "watcherCount"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "tagsWatchedByUser(first:3)"
                          },
                          {
                            "args": (v31/*: any*/),
                            "concreteType": "TeamConnection",
                            "kind": "LinkedField",
                            "name": "teamsWatchedByUser",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TeamEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Team",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v18/*: any*/),
                                      (v24/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "teamId"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "teamsWatchedByUser(first:3)"
                          }
                        ]
                      },
                      {
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": [
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v37/*: any*/),
                          (v38/*: any*/)
                        ]
                      },
                      (v26/*: any*/),
                      (v30/*: any*/),
                      {
                        "concreteType": "GoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "GoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  },
                                  {
                                    "concreteType": "MetricValue",
                                    "kind": "LinkedField",
                                    "name": "newValue",
                                    "plural": false,
                                    "selections": (v39/*: any*/)
                                  },
                                  {
                                    "concreteType": "Metric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v18/*: any*/),
                                      (v24/*: any*/),
                                      (v40/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "subType"
                                      },
                                      (v41/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "MetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": (v39/*: any*/)
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "GoalProgress",
                        "kind": "LinkedField",
                        "name": "newProgress",
                        "plural": false,
                        "selections": [
                          (v40/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "percentage"
                          }
                        ]
                      },
                      {
                        "concreteType": "CommentConnection",
                        "kind": "LinkedField",
                        "name": "comments",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v18/*: any*/),
                                  (v42/*: any*/),
                                  (v26/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "commentText"
                                  },
                                  (v30/*: any*/),
                                  {
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "creator",
                                    "plural": false,
                                    "selections": [
                                      (v21/*: any*/),
                                      {
                                        "concreteType": "UserPII",
                                        "kind": "LinkedField",
                                        "name": "pii",
                                        "plural": false,
                                        "selections": [
                                          (v22/*: any*/),
                                          (v24/*: any*/),
                                          (v25/*: any*/),
                                          (v23/*: any*/)
                                        ]
                                      },
                                      (v18/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__id"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v24/*: any*/)
                            ]
                          },
                          (v18/*: any*/)
                        ]
                      },
                      (v42/*: any*/),
                      {
                        "concreteType": "TargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v44/*: any*/)
                      },
                      (v45/*: any*/),
                      {
                        "concreteType": "UpdateNote",
                        "kind": "LinkedField",
                        "name": "notes",
                        "plural": true,
                        "selections": [
                          (v41/*: any*/),
                          (v20/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "title"
                          },
                          (v45/*: any*/),
                          (v18/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v44/*: any*/)
                      },
                      {
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": [
                          (v35/*: any*/),
                          (v37/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v38/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "Project",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                  (v28/*: any*/),
                                  (v18/*: any*/)
                                ]
                              }
                            ],
                            "type": "ProjectUpdate"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "url"
                              }
                            ],
                            "type": "GoalUpdate"
                          }
                        ],
                        "type": "Update",
                        "abstractKey": "__isUpdate"
                      }
                    ],
                    "type": "GoalUpdate"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v27/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v19/*: any*/),
        "filters": [
          "workspaceId",
          "createdBefore",
          "createdAfter",
          "stateFilter"
        ],
        "handle": "connection",
        "key": "GoalUpdatesList_allWatchedGoalUpdates",
        "kind": "LinkedHandle",
        "name": "allWatchedGoalUpdates"
      },
      {
        "alias": "currentSummary",
        "args": [
          (v10/*: any*/),
          (v11/*: any*/),
          (v13/*: any*/)
        ],
        "concreteType": "StatusSummary",
        "kind": "LinkedField",
        "name": "goalStatusSummary",
        "plural": false,
        "selections": (v46/*: any*/)
      },
      {
        "alias": "previousSummary",
        "args": [
          {
            "kind": "Variable",
            "name": "endDate",
            "variableName": "startDate"
          },
          {
            "kind": "Variable",
            "name": "startDate",
            "variableName": "prevDate"
          },
          (v13/*: any*/)
        ],
        "concreteType": "StatusSummary",
        "kind": "LinkedField",
        "name": "goalStatusSummary",
        "plural": false,
        "selections": (v46/*: any*/)
      },
      {
        "condition": "isNavRefreshEnabled",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "ownGoals",
            "args": [
              (v47/*: any*/),
              {
                "kind": "Variable",
                "name": "q",
                "variableName": "ownGoalsTqlQuery"
              },
              {
                "kind": "Literal",
                "name": "sorts",
                "value": [
                  "NAME_ASC"
                ]
              },
              (v15/*: any*/)
            ],
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "goalTql",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v28/*: any*/),
                      (v20/*: any*/),
                      (v29/*: any*/),
                      (v24/*: any*/),
                      {
                        "concreteType": "UserConnection",
                        "kind": "LinkedField",
                        "name": "watchers",
                        "plural": false,
                        "selections": (v17/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "newGoals",
            "args": [
              (v47/*: any*/),
              {
                "kind": "Variable",
                "name": "q",
                "variableName": "newGoalsTqlQuery"
              },
              (v48/*: any*/),
              (v15/*: any*/)
            ],
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "goalTql",
            "plural": false,
            "selections": (v49/*: any*/)
          },
          {
            "alias": "completedGoals",
            "args": [
              (v47/*: any*/),
              {
                "kind": "Variable",
                "name": "q",
                "variableName": "completedGoalsTqlQuery"
              },
              (v48/*: any*/),
              (v15/*: any*/)
            ],
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "goalTql",
            "plural": false,
            "selections": (v49/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "084d42e0b266974d4e45c1bb9e8d946a",
    "id": null,
    "metadata": {},
    "name": "GoalUpdatesViewQuery",
    "operationKind": "query",
    "text": "query GoalUpdatesViewQuery(\n  $prevDate: DateTime\n  $startDate: DateTime\n  $endDate: DateTime\n  $workspaceId: ID!\n  $workspaceUUID: UUID!\n  $stateFilter: UpdateStateFilter\n  $ownGoalsTqlQuery: String!\n  $newGoalsTqlQuery: String!\n  $completedGoalsTqlQuery: String!\n  $isNavRefreshEnabled: Boolean!\n) {\n  ...GoalUpdatesMainColumn_352XcS\n  ...GoalUpdatesSideColumn_YUpuN @skip(if: $isNavRefreshEnabled)\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment GoalDateChanged on GoalUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalFollowButton on Goal {\n  id\n  uuid\n  watching\n}\n\nfragment GoalFollowersButton on Goal {\n  key\n  watchers {\n    count\n  }\n}\n\nfragment GoalMissedUpdateLabel on GoalUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  goal {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment GoalProgressChanged on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          type\n          subType\n          archived\n          id\n        }\n        newStartValue\n        newValue {\n          value\n          id\n        }\n        oldValue {\n          value\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalRowWithFollowers on Goal {\n  key\n  ...GoalName\n  ...GoalFollowersButton\n}\n\nfragment GoalRowWithOwner on Goal {\n  key\n  ...GoalName\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  goalStateValue: value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment GoalStatusChanged on GoalUpdate {\n  newState {\n    ...GoalState\n  }\n  oldState {\n    ...GoalState\n  }\n}\n\nfragment GoalUpdateCardByline on Goal {\n  watching\n  tagsWatchedByUser(first: 3) {\n    edges {\n      node {\n        ...Tag\n        id\n      }\n    }\n  }\n  teamsWatchedByUser(first: 3) {\n    edges {\n      node {\n        id\n        name\n        teamId\n      }\n    }\n  }\n}\n\nfragment GoalUpdateCardFooter on GoalUpdate {\n  id\n  ari\n  updateType\n  missedUpdate\n  goal {\n    ari\n    ...GoalFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment GoalUpdateCardHeader on GoalUpdate {\n  id\n  newState {\n    value\n    score\n  }\n  goal {\n    ...GoalFollowButton\n    parentGoal {\n      id\n    }\n    key\n    name\n    ...PlatformGoalIcon\n    id\n  }\n}\n\nfragment GoalUpdateCardInternal on GoalUpdate {\n  id\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop\n  ...GoalUpdateSummary\n  notes {\n    ...UpdateNote\n    id\n  }\n  ...GoalUpdateDiff\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment GoalUpdateCardProgress on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        newStartValue\n        newTargetValue\n        newValue {\n          value\n          id\n        }\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n        }\n      }\n    }\n  }\n  newProgress {\n    type\n    percentage\n  }\n  goal {\n    id\n    subGoals {\n      count\n    }\n    metricTargets {\n      edges {\n        node {\n          startValue\n          targetValue\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalUpdateCardTop on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalUpdateCreationDate\n  ...GoalUpdateStatus\n  ...GoalMissedUpdateLabel\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCardTop_PTxnb on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalMissedUpdateLabel\n  missedUpdate\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCard_3UosK1 on GoalUpdate {\n  id\n  uuid\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...MissedGoalUpdateCard\n  ...GoalUpdateCardInternal\n  goal {\n    uuid\n    ...GoalUpdateCardByline\n    id\n  }\n}\n\nfragment GoalUpdateCreationDate on GoalUpdate {\n  id\n  goal {\n    key\n    id\n  }\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n  creationDate\n  editDate\n}\n\nfragment GoalUpdateDiff on GoalUpdate {\n  ...GoalDateChanged\n  ...GoalStatusChanged\n  ...GoalProgressChanged\n}\n\nfragment GoalUpdateStatus on GoalUpdate {\n  newState {\n    goalStateValue: value\n    ...GoalState\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalUpdateSummary on GoalUpdate {\n  summary\n}\n\nfragment GoalUpdatesFeed_2SEHUt on Query {\n  currentUser {\n    goalsWatching(workspaceId: $workspaceId) {\n      count\n    }\n    id\n  }\n  ...GoalUpdatesList_1j3MN4\n  ...GoalUpdatesStatusSummary_2oYDyA\n  currentSummary: goalStatusSummary(startDate: $startDate, endDate: $endDate, workspaceId: $workspaceId) {\n    atRisk\n    onTrack\n    offTrack\n    missed\n    done\n    cancelled\n  }\n}\n\nfragment GoalUpdatesList_1j3MN4 on Query {\n  allWatchedGoalUpdates(workspaceId: $workspaceId, first: 10, createdBefore: $endDate, createdAfter: $startDate, stateFilter: $stateFilter) {\n    edges {\n      node {\n        __typename\n        ...GoalUpdateCard_3UosK1\n        ... on GoalUpdate {\n          id\n          goal {\n            id\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment GoalUpdatesMainColumn_352XcS on Query {\n  currentUser {\n    goalsWatching(workspaceId: $workspaceId) {\n      count\n    }\n    id\n  }\n  allWatchedGoalUpdatesCount(workspaceUUID: $workspaceUUID, stateFilter: ACTIVE)\n  ...GoalUpdatesFeed_2SEHUt\n}\n\nfragment GoalUpdatesSideColumn_YUpuN on Query {\n  ownGoals: goalTql(first: 20, workspaceUuid: $workspaceUUID, q: $ownGoalsTqlQuery, sorts: [NAME_ASC]) {\n    ...GoalWithFollowersSidebarSection\n  }\n  newGoals: goalTql(first: 20, workspaceUuid: $workspaceUUID, q: $newGoalsTqlQuery, sorts: [CREATION_DATE_DESC]) {\n    ...GoalWithOwnerSidebarSection\n  }\n  completedGoals: goalTql(first: 20, workspaceUuid: $workspaceUUID, q: $completedGoalsTqlQuery, sorts: [CREATION_DATE_DESC]) {\n    ...GoalWithOwnerSidebarSection\n  }\n}\n\nfragment GoalUpdatesStatusSummary_2oYDyA on Query {\n  currentSummary: goalStatusSummary(startDate: $startDate, endDate: $endDate, workspaceId: $workspaceId) {\n    active\n    missed\n    atRisk\n    onTrack\n    offTrack\n    done\n    cancelled\n  }\n  previousSummary: goalStatusSummary(startDate: $prevDate, endDate: $startDate, workspaceId: $workspaceId) {\n    active\n    missed\n    atRisk\n    onTrack\n    offTrack\n    done\n    cancelled\n  }\n}\n\nfragment GoalWithFollowersSidebarSection on GoalConnection {\n  count\n  edges {\n    node {\n      id\n      ...GoalRowWithFollowers\n    }\n  }\n}\n\nfragment GoalWithOwnerSidebarSection on GoalConnection {\n  count\n  edges {\n    node {\n      id\n      ...GoalRowWithOwner\n    }\n  }\n}\n\nfragment MissedGoalUpdateCard on GoalUpdate {\n  id\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop_PTxnb\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ShareUpdateButton on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n  }\n  ... on GoalUpdate {\n    id\n  }\n  ...ShareUpdateDialogContent\n}\n\nfragment ShareUpdateDialogContent on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n    project {\n      key\n      id\n    }\n  }\n  ... on GoalUpdate {\n    id\n    url\n    goal {\n      key\n      id\n    }\n  }\n}\n\nfragment Tag on Tag {\n  ...Tag_createTagOption\n}\n\nfragment Tag_createTagOption on Tag {\n  id\n  name\n  uuid\n  description\n  projectUsageCount\n  goalUsageCount\n  helpPointerUsageCount\n  watcherCount\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment UpdateNote on UpdateNote {\n  archived\n  uuid\n  title\n  summary\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserName on User {\n  aaid\n  pii {\n    name\n    accountStatus\n  }\n}\n"
  }
};
})();

(node as any).hash = "25dcc009b4d702fde8a197682b6f0165";

export default node;
